import _ from "underscore";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import I18n from "./locale/I18n";
import ImageLearning from "./images/ImageLearning";
import ImageVet from "./images/ImageVet";
import Link from "./Link";
import Part from "./Part";
import React from "react";

const Products = props => {
    const products = [
        {
            id: "learning",
            image: <ImageLearning />,
            name: <I18n label="Product_Learning" />,
            description: <I18n label="Product_Learning_Desc" />,
            target: "/IsyLearning"
        },
        {
            id: "vet",
            image: <ImageVet />,
            name: <I18n label="Product_Vet" />,
            description: <I18n label="Product_Vet_Desc" />,
            target: "/IsyVet"
        }
    ];
    return (
        <Part title={<I18n label="Products" />}>
            <Grid container spacing={2}>
                {_.map(products, product => (
                    <Grid key={product.id} item xs={12} sm={6}>
                        <Link
                            target={product.target}
                            style={{ textDecoration: "none" }}
                        >
                            <Card key={product.id}>
                                <CardHeader title={product.name} />
                                <CardMedia>{product.image}</CardMedia>
                                <CardContent>{product.description}</CardContent>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Part>
    );
};

export default Products;
